/* eslint-disable no-unused-vars */
export default {
  init() {
    // JavaScript to be fired on all pages

    // search results lazy loader
    $('.search-list-results').on('click', '.load-more a', function(e) {
      e.preventDefault();
      var element = $(this),
          target = $(this).attr('href'),
          target_container = $(this).parent('.load-more');

      $(this).removeClass('inactive');
      $(this).addClass('active');

      $.ajax({
        url:target,
        type:'GET',
        success: function(data) {
          data = $(data).find('.search-list-results').html();
          $(target_container).replaceWith(data);
        },
      });

    });

    // search filters functionality
    function search_filters_update_json( children ) {
      var values = [];

      $(children).each(function() {
        values.push( $(this).val() );
      })

      return values;
    }

    function search_filters_update_button( values ) {
      var button = $('.search-filters button'),
          status = $(button).data('current');

      if( status === values.join() ) {
        $(button).prop('disabled', true);
      } else {
        $(button).removeAttr('disabled');
      }
    }

    $('.search-filters').on('click', 'input', function() {
      var parent = $('.search-filters'),
          children = $(parent).find('input[type="checkbox"]:checked'),
          input = $('input[name="pt"]'),
          values = search_filters_update_json(children);

        $(input).val(values);
        search_filters_update_button(values);

    });

    // Knowledge hub / multi-post listings AJAX (works for modules and archive pages etc)
    $('.multi-post-output').on('click', '.read-more a', function(e) {
      e.preventDefault();

      var target = $(this).attr('href'),
          target_container = $(this).closest('.read-more'),
          node = $(this).parents('[data-node]').data('node');

      $(this).parents('.multi-post-wrapper').addClass('loading');

      $(this).removeClass('inactive');
      $(this).addClass('active');

      // console.log(node);

      $.ajax({
        url:target,
        type:'get',
        success: function(data) {
          data = $(data).find('[data-node="' + node + '"] .multi-post-output').html();
          $(target_container).replaceWith(data);
          $('.multi-post-wrapper').removeClass('loading');
        },
      });

    });

    $('#collapseCategories').on('show.bs.collapse', function () {
       $('.category-toggle .wrapper').addClass('is-collapsed');
    });
    $('#collapseCategories').on('hidden.bs.collapse', function () {
       $('.category-toggle .wrapper').removeClass('is-collapsed');
    });

    function knowledge_hub_filter( form ) {
      // alert('test');
      // console.log('Filtering triggered');

      var form_data = $(form).serializeArray();

      var target = $(form).attr('action'),
          target_container = $('.multi-post-output');

      $(target_container).parent().addClass('loading');

      $.ajax({
          url : target,
          type : 'get',
          data: form_data,
          success : function(data) {
            data = $(data).find('.multi-post-output').html();
            $(target_container).html(data);
            $(target_container).parent().removeClass('loading');
          },
          error: function() {
            // do something
          },
      });

    }

    $('.knowledge-hub .filter').on('change', 'select', function(e) {
      e.preventDefault();
      knowledge_hub_filter( $(this).closest('form') );
    });

    $('.knowledge-hub form').submit(function(e) {
      e.preventDefault();
      knowledge_hub_filter( $(this) );
    });

    // Select2
    var $select2 = $('.knowledge-hub select');

    $select2.each(function() {
      let placeholder_text = $(this).data('placeholder'); console.log(placeholder_text);
      $(this).select2({
        placeholder: placeholder_text,
        allowClear: true,
      });
    })

    // Carousels code
    let $carousels = $('.cmi-custom-module.carousel');

    if( $carousels.length > 0) {

      let $carousel = [],
          $carousel_nav = [],
          $args = [];

      $args.generic = {
        loop: true,
        margin: 20,
        nav: false,
        responsive: {
          0: {
            items: 1,
            margin: 5,
            stagePadding: 20,
          },
          576: {
            items: 2,
            margin: 10,
            stagePadding: 40,
          },
          768: {
            items: 2,
            stagePadding: 2,
          },
          992: {
            items: 3,
            stagePadding: 2,
          },
        },
      };

      $args.biographies = {
        loop: true,
        margin: 40,
        responsive: {
          0: {
            items: 1,
            margin: 5,
            stagePadding: 30,
          },
          576: {
            items: 2,
            margin: 10,
            stagePadding: 50,
          },
          768: {
            items: 3,
            stagePadding: 2,
          },
          992: {
            items: 4,
            stagePadding: 2,
          },
        },
      };

      $carousels.each(function(i) {

        // apply a random string to each carousel to differetieate it from other carousels on the page
        var rnd = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

        $carousel[rnd] = $(this).find('.carousel-wrap');

        $carousel_nav[rnd] = $(this).find('.carousel-nav');

        if( $(this).hasClass('generic') ) {
          $carousel[rnd].owlCarousel($args.generic);
        }

        if( $(this).hasClass('biographies') ) {
          $carousel[rnd].owlCarousel($args.biographies);
        }

        $carousel_nav[rnd].on('click', function(e) {
          if( $(this).hasClass('carousel-prev') ) {
            $carousel[rnd].trigger('prev.owl.carousel');
          }
          if( $(this).hasClass('carousel-next') ) {
            $carousel[rnd].trigger('next.owl.carousel');
          }
        });
      });

    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js